var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-bar-guidance"},[_c('p',[_vm._v(" 点击右上角，在"),_c('img',{staticClass:"icon-safari",attrs:{"src":require('@/assets/common/safarilogo.png')}}),_vm._v(" 浏览器打开 ")]),_c('p',[_vm._v("可以继续访问本站哦~")])])
}
var staticRenderFns = []

export { render, staticRenderFns }